module.exports = __webpack_public_path__ + "media/icons/instagram-a08ea2bd.png";